module.exports = __webpack_public_path__ + "static/media/education-object-4-1-2.5f7e20ed.svg";